import { useContext, useEffect, useState } from "react";
import { TimeoutWarningModal } from "./TimeoutWarningModal";
import {
  addEventListeners,
  removeEventListeners,
} from "./util/EventListenerUtil";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../App";

// Update log
// FB  6192   02/06/2023  DK   Added page to handle session time out 

export const TimeOut = (props) => {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const context = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (context.userLoggedIn) {
      const createTimeout1 = () =>
        setTimeout(() => {
          setWarningModalOpen(true);
        }, 10000 * 60);

      const createTimeout2 = () =>
        setTimeout(() => {
          sessionStorage.removeItem("user");
          navigate("/user/login");
          setWarningModalOpen(false);
          context.setUserLoggedIn(false);
        }, 20000);

      const listener = () => {
        if (!isWarningModalOpen) {
          clearTimeout(timeout);
          timeout = createTimeout1();
        }
      };

      // Initialization
      let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1();
      addEventListeners(listener);

      // Cleanup
      return () => {
        removeEventListeners(listener);
        clearTimeout(timeout);
      };
    }
  }, [isWarningModalOpen, context.userLoggedIn]);

  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={() => { setWarningModalOpen(false) }}
        />
      )}
    </div>
  );
};
